<template>
<div>
    <el-table
    :data="tableData"
    stripe
    max-height="400"
    style="width: 100%;">
    <el-table-column
      prop="name"
      align="center"
      label="Name"
      min-width="120">
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip='true'
      prop="email"
      align="center"
      label="Email Id"
      min-width="200">
    </el-table-column>
    <el-table-column
      prop="sectionA"
      align="center"
      min-width="170"
      label="Quantitative Aptitude">
    </el-table-column>
    <el-table-column
      prop="sectionB"
      align="center"
      min-width="160"
      label="Data Interpretation">
    </el-table-column>
    <el-table-column
      prop="sectionC"
      align="center"
      min-width="160"
      label="Coding Ability">
    </el-table-column>
    <el-table-column
      prop="total"
      align="center"
      min-width="150"
      label="Total">
    </el-table-column>
  </el-table>
</div>
</template>
<script>
export default {
  props: ['tableData'],
  data () {
    return {
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Result/ResultTable.vue